<template>
  <div class="footer-wrapper">
    <div class="max-width">
      <img class="footer-img" src="/static/img/footer-logo.png" alt>
      <div class="footer-nav-wrapper">
        <div class="nav-item">
          <div @click="toPage({name:'centerIntro',query:{otype:1}})">中心简介</div>
          <div @click="toPage({name:'centerIntro',query:{otype:2}})">组织架构图</div>
          <div @click="toPage({name:'centerIntro',query:{otype:3}})">中心领导</div>
          <div @click="toPage({name:'centerIntro',query:{otype:4}})">部门职责</div>
        </div>
        <div class="nav-item">
          <!-- <a href="http://www.ncosm.org.cn/ncosm/portal/index">标准管理</a> -->
          <!-- <div>计量标准</div>
          <div>质量标准</div>-->
          <div @click="toPage({name:'centerIntro',query:{otype:1}})">关于我们</div>
        </div>
        <div class="nav-item">
          <div
            @click="toPage({name:'CooperMajor', query: {
            showFlag2: 0,
            type: 1
          }})"
          >重大专项</div>
          <div
            @click="toPage({name:'CooperMajor', query: {
            showFlag2: 1,
            type: 2
          }})"
          >国际合作</div>
          <div @click="toPage({name:'education'})">教育培训</div>
          <div @click="toPage({name:'recruitment'})">人才招聘</div>
        </div>
        <div class="nav-item">
          <div  @click="toPage({name:'contractUs'})">联系我们</div>
          <div  @click="toPage({name:'statement'})">版权声明</div>
          <div>设为首页</div>
          <div>加入收藏</div>
        </div>
      </div>
      <div class="last-footer">
        <router-link to='/supervise' class="tel">
          <img class="footer-img1" src="/static/img/tel.png" alt>
          <span>纪检监察监督举报</span>
        </router-link>
        <img class="footer-img2" src="/static/img/shiye.png" alt>
        <div>
          <img class="footer-img3" src="/static/img/hui.png" alt>
          <span>津公网安备 12010402000540号</span>
        </div>
      </div>
      <div class="bo-style">网站标识码：CA330000000604222390001</div>
      <div class="bo-style"><a href="http://www.beian.miit.gov.cn/publish/query/indexFirst.action" style="font-weight: normal;color: #FFFFFF;">版权所有 国家海洋标准计量中心 津ICP备 08002640号-3</a></div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["touchflg"])
  },
  methods: {
    toPage(url) {
      if (this.touchflg) {
        this.$router.push(url);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../common/minix.less";
.footer-wrapper {
  margin-top: 30 / @rem;
  width: 100%;
  height: 692 / @rem;
  background: url("/static/img/footer-bj.png") no-repeat center center;
  background-size: 750 / @rem 692 / @rem;
  font-size: 24 / @rem;
  padding: 30 / @rem 0;
  box-sizing: border-box;
  .max-width {
    width: 690 / @rem;
    margin: 0 auto;
  }
}
.footer-img {
  width: 217 / @rem;
  height: 217 / @rem;
  display: block;
  margin: 0 auto;
}
.footer-nav-wrapper {
  width: 690 / @rem;
  margin: 31 / @rem auto 80 / @rem;
  font-size: 24 / @rem;
  display: flex;
  color: #c5d8fc;
}
.nav-item {
  width: 25%;
  border-right: 1px solid #8999b6;
  line-height: 50 / @rem;
  text-align: center;
  a {
    font-size: 24 / @rem;
    opacity: 1;
    font-weight: normal;
    display: block;
    line-height: 50 / @rem;
    height: 50 / @rem;
    color: #c1d9ff;
  }
  div {
    display: block;
    line-height: 50 / @rem;
    height: 50 / @rem;
    color: #c1d9ff;
  }
}
.nav-item:last-child {
  border-right: none;
}
.bo-style {
  font-size: 20 / @rem;
  line-height: 40 / @rem;
  text-align: center;
  color: #ffffff;
}
.last-footer {
  display: flex;
  font-size: 20 / @rem;
  line-height: 40 / @rem;
  color: #ffffff;
  align-items: center;
  justify-content: space-around;
  .tel {
    color: #fff;
    outline: none;
    img,
    span {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .footer-img1 {
    width: 38 / @rem;
    height: 38 / @rem;
  }
  .footer-img2 {
    width: 57 / @rem;
    height: 50 / @rem;
  }
  .footer-img3 {
    width: 18 / @rem;
    height: 20 / @rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue